import script from "./MedadminshortOrderTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./MedadminshortOrderTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./MedadminshortOrderTemplate.vue?vue&type=style&index=0&id=0619f6cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0619f6cb"]])

export default __exports__